import { useRef } from "react";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";

const LendingPartnerScroller = ({ lendingPartnersCardsData }) => {
  const scrollRef = useRef();

  function amountFormat(x, defaultValue = 0) {
    if (!x) {
      return defaultValue;
    }
    x = x.toString();
    var afterPoint = "";
    if (x?.indexOf(".") > 0)
      afterPoint = x.substring(x?.indexOf("."), x?.length);
    x = Math.floor(x);
    x = x?.toString();
    var lastThree = x?.substring(x?.length - 3);
    var otherNumbers = x?.substring(0, x?.length - 3);
    if (otherNumbers != "") lastThree = "," + lastThree;
    var res =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      lastThree +
      afterPoint;
    return res;
  }

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = 300;
      current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="position-relative">
      {/* Scroll buttons */}
      <button
        onClick={() => scroll("left")}
        className="position-absolute top-50 translate-middle-y text-light rounded-circle shadow-sm z-1 border-0"
        style={{ left: "-20px", backgroundColor: "#11182725" }}
      >
        <IconButton
          sx={{
            bgcolor: "#e9f2ff99",
            "&:hover": {
              bgcolor: "#d0e4ff99",
            },
          }}
        >
          <KeyboardDoubleArrowLeftIcon
            sx={{ fontSize: 30, color: "#4167f3" }}
          />
        </IconButton>
        {/* <KeyboardDoubleArrowLeftIcon size={24} sx={{color:'#111827'}}/> */}
      </button>

      <button
        onClick={() => scroll("right")}
        className="position-absolute top-50 translate-middle-y text-light rounded-circle shadow-sm z-1 border-0"
        style={{ right: "-20px", backgroundColor: "#11182725" }}
      >
        <IconButton
          sx={{
            bgcolor: "#e9f2ff99",
            "&:hover": {
              bgcolor: "#d0e4ff99",
            },
          }}
        >
          <KeyboardDoubleArrowRightIcon
            sx={{ fontSize: 30, color: "#4167f3" }}
          />
        </IconButton>
      </button>

      {/* Scrollable card container */}
      <div
        ref={scrollRef}
        className="d-flex overflow-auto align-items-center gap-3 scrollbar-hide"
      >
        {lendingPartnersCardsData?.map((item, index) => (
          <div key={index} className="min-w-[250px] flex-shrink-0">
            <Card sx={{ minWidth: "100%" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  component="div"
                  className="fw-bolder text-center"
                >
                  {item?.lending_partner_name}
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  className="text-center"
                >
                  <span style={{ color: "#450a0a" }}>Amount: </span>
                  <span style={{ color: "#1e3a8a" }}>
                    ₹ {amountFormat(Number(item?.available_limit).toFixed(2))}
                  </span>
                </Typography>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LendingPartnerScroller;
